var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["useValueChange"]: () => __WEBPACK_EXTERNAL_MODULE__leverege_ui_hooks_f7f57535__.useValueChange });